module.exports = {"addTag":"+ Tag toevoegen","add":"Toevoegen","close":"Sluit","tagPlaceholder":"Typ hier je tag..."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Tags/localization/nl-NL/strings.json
// module id = 1203
// module chunks = 0